import React, { FC, useState, FormEvent, ChangeEvent, useCallback } from 'react';
import styled from 'styled-components';
import { StyledButton, StyledSecondaryButton } from './_signup';
import { Heading } from '~/elements/Heading';
import { Container } from '~/elements/Container';
import { Icon } from '~/elements/Icon';
import { Section } from '~/elements/Section';
import { Grid } from '~/elements/Grid';
import { Flex } from '~/elements/Flex';
import { Column } from '~/elements/Column';
import { ButtonGroup } from '~/elements/ButtonGroup';
import { Text } from '~/elements/NewText';
const StyledContainer = styled(Container)`
  position: relative;
  z-index: 1;
`;

const StyledEyebrow = styled(Heading)`
  background-color: var(--color-cyan-800);
  color: var(--color-white);
  padding: 4px 10px 4px 10px;
  border-radius: 8px;
  margin: 0 0 48px 0;
  box-shadow: inset 0 0 0 1px rgba(var(--rgb-black), 0.05);
  line-height: 1;

  .typing {
    &::after {
      display: none;
    }
  }
`;

export const SectionSignupBottom: FC = () => {
  const [currentState, setCurrentState] = useState<'success' | 'error' | ''>('');
  const [email, setEmail] = useState<string>('');

  const handleInputChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  }, []);

  const onSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      setCurrentState('');

      fetch('https://api.column.com/newsletter/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          category: 'realtime',
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            setCurrentState('success');
            return;
          }
          setCurrentState('error');
        })
        .catch(() => {
          setCurrentState('error');
        });
    },
    [currentState, email]
  );

  return (
    <Section py={{ _: 12, md: 40 }}>
      <StyledContainer>
        <Grid gridTemplateColumns={12} gapY={6}>
          <Column gridColumn={12}>
            <Flex flexDirection="column" alignItems="center" height="100%">
              <StyledEyebrow size="200" weight="medium">
                Get Started
              </StyledEyebrow>
              <Heading weight="semibold" size="1000" color="cyan-800" as="h2" textAlign="center">
                Start building with Realtime
              </Heading>
              <Text
                size="600"
                weight="semibold"
                color="rgba(var(--rgb-cyan-800), 0.65)"
                textAlign="center"
                pt={{ _: 1, lg: 4 }}
                pb={6}
              >
                Instant, transparent, and available 24/7/365
              </Text>
              <ButtonGroup justifyContent={{ _: 'center', nav: 'start' }}>
                <StyledButton href="https://dashboard.column.com/register" type="link" variant="primary">
                  Start building <Icon.AnimatedArrowRight />
                </StyledButton>
                <StyledSecondaryButton to="/docs/realtime">Documentation</StyledSecondaryButton>
              </ButtonGroup>
            </Flex>
          </Column>
        </Grid>
      </StyledContainer>
    </Section>
  );
};

export default SectionSignupBottom;
